import React, { useEffect, useState } from "react"
import _get from "lodash/get"
import _isEmpty from "lodash/isEmpty"
import { useRouter } from "next/router"
import { useDispatch, useSelector } from "react-redux"
import useMyFavoritesi18n from "@/i18n/useMyfavoritesi18n"
import {
  getMyAccountFavorites,
  myAccountRemoveItems,
  getMyAccountListsWithLineItems,
} from "@/store/features/favoritesSlice"
import { selectAuthState, logout } from "@/store/features/authSlice"
import { selectFavoritesState } from "@/store/features/favoritesSlice"
import { getSortItemBasedOnURL } from "@/utils/helper"
import { showToast, selectGenericState } from "@/store/features/genericSlice"

import { preventBodyScroll, getShortenedUrlwithGeneral } from "@/utils/helper"
import { setMenu } from "@/utils/orders"
import { getShortenedUrl } from "@/utils/location"
import { getBrandSwitcher } from "@/utils"

import { getConfig } from "@/constants/config"
import { PRODUCTS_PER_PAGE } from "@/constants"
import FavoritesView from "@/components/MyFavorites/v1/Favorites.view"
import MyGenericFiller from "@/components/MyGenericFiller"
import { MY_LISTS_PAGE_PATH } from "@/constants/routes"

const MyFavorites = props => {
  const router = useRouter()
  const dispatch = useDispatch()

  const { isAuth, user } = useSelector(selectAuthState)

  const {
    fullFavoriteData: fav = {},
    userLists = [],
    status,
  } = useSelector(selectFavoritesState)
  const { sortProducts: lineItems = [], sortMedia: textLineItems = [] } =
    fav ?? {}

  const {
    data: componentProps = {},
    header,
    siteName = "",
  } = props ?? {
    title: "",
    description: "",
  }
  const brandSwitcherItems = getBrandSwitcher(header)

  const { presetConfigs } = componentProps

  const [editMode, setEditMode] = useState(false)
  const [selectedItems, setSelectedItems] = useState([])
  const [selectedAll, setSelectedALL] = useState(false)

  const [menuItems, setMenuItems] = useState([])
  const [configData, setInitialConfigData] = useState({})
  const {
    toaster,
    featureFlags = {},
    globalConfig: { internationalization: { language = "" } = {} } = {},
  } = useSelector(selectGenericState)
  const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false } =
    featureFlags
  const staticTexts = useMyFavoritesi18n({
    componentProps,
    selectedItems,
    isSaveProductToList,
  })

  const [config, setInitialConfig] = useState({})
  const [loader, setLoader] = useState(true)
  const [tabListItm, setTabListItm] = useState([])
  const selectedSortItem = getSortItemBasedOnURL(staticTexts, {
    name: "Featured",
  })

  const [toasterContent, setToasterContent] = useState({
    successMessage: "",
    unfavoriteSuccessMessage: "",
  })

  if (isSaveProductToList) {
    staticTexts.favorites = staticTexts?.myLists
  }

  const setToasterMessage = general => {
    if (!_isEmpty(toaster?.content)) {
      const { successMessage = "", unfavoriteSuccessMessage = "" } =
        toaster.content
      setToasterContent({
        successMessage: getShortenedUrlwithGeneral(successMessage, general),
        unfavoriteSuccessMessage: getShortenedUrlwithGeneral(
          unfavoriteSuccessMessage,
          general
        ),
      })
    }
  }

  useEffect(() => {
    getConfig().then(config => {
      const locale = _get(config, "internationalization.locale", "")

      const currencyCode = _get(config, "internationalization.currencyCode", "")
      const currencySign = _get(config, "internationalization.currencySign", "")
      const continueShopUrl = _get(config, "general.continueShopPath", "")

      setInitialConfigData({
        locale,
        currencyCode,
        currencySign,
        continueShopUrl,
      })

      setInitialState(config)
      setToasterMessage(config?.general)
    })
    window.scrollTo({
      top: 1,
      behavior: "smooth",
    })
  }, [])

  useEffect(() => {
    if (isSaveProductToList) return
    const tabListData = []
    const filterByType = type =>
      textLineItems?.filter(item => item?.custom?.fields?.itemType === type)
    if (lineItems.length || textLineItems.length) {
      if (lineItems?.length) {
        tabListData?.push({
          title: staticTexts?.productsTab,
          data: lineItems,
        })
      }

      if (filterByType("image")?.length) {
        tabListData?.push({
          title: staticTexts?.imagesTab,
          data: filterByType("image"),
        })
      }
      if (filterByType("video")?.length) {
        tabListData?.push({
          title: staticTexts?.videosTab,
          data: filterByType("video"),
        })
      }
      if (filterByType("article")?.length) {
        tabListData?.push({
          title: staticTexts?.articlesTab,
          data: filterByType("article"),
        })
      }
      tabListData?.push({
        title: staticTexts?.allTab,
        data: [...lineItems, ...textLineItems]?.sort(
          (a, b) => new Date(b.addedAt) - new Date(a.addedAt)
        ),
      })
    } else {
      setTabListItm([])
    }

    if (tabListData.length) {
      setTabListItm(tabListData)
    }
  }, [lineItems?.length, textLineItems?.length, isSaveProductToList])

  useEffect(() => {
    if (isSaveProductToList) {
      const tabListData = []
      if (userLists.length) {
        tabListData?.push({
          title: staticTexts?.lists,
          data: userLists,
        })
      } else {
        tabListData?.push({
          title: staticTexts?.lists,
          data: [],
        })
      }
      const allItemsList = userLists?.filter(list => {
        return list?.name["en-US"] === "Favorites"
      })
      if (allItemsList.length && allItemsList[0]?.textLineItems.length) {
        const textLineItems = allItemsList[0]?.textLineItems ?? []
        tabListData?.push({
          title: staticTexts?.media,
          data: [...textLineItems].sort(
            (a, b) => new Date(b.addedAt) - new Date(a.addedAt)
          ),
        })
      }
      setTabListItm(tabListData)
    }
  }, [userLists])

  useEffect(() => {
    if (isAuth) {
      dispatch(getMyAccountFavorites())
        .unwrap()
        .finally(() => setLoader(false))
    }
  }, [isAuth, isSaveProductToList])
  useEffect(() => {
    if (!_isEmpty(config)) {
      const menuItemsList = setMenu(
        config,
        staticTexts,
        language,
        isSaveProductToList
      )
      if (isSaveProductToList) {
        menuItemsList.forEach(item => {
          if (item?.title == staticTexts?.favorites) {
            item.title = staticTexts?.myLists
          }
        })
      }
      setMenuItems(menuItemsList)
    }
  }, [config, isSaveProductToList])

  const setInitialState = async config => {
    const accountSettingsPath = await getShortenedUrl(
      _get(config, "general.accountSettingsPath", "")
    )
    const myFavoritesPagePath = await getShortenedUrl(
      _get(config, "general.myFavoritesPagePath", "")
    )
    const orderHistoryPath = await getShortenedUrl(
      _get(config, "general.orderHistoryPath", "")
    )
    const myProductsPath = await getShortenedUrl(
      _get(config, "general.myProductsPath", "")
    )
    const myServicesPath = await getShortenedUrl(
      _get(config, "general.myServicesPath", "")
    )
    const orderDetailsUrl = _get(config, "general.orderDetailsPath", "")
    const continueShopUrl = _get(config, "general.continueShopPath", "")
    const currencySign = _get(config, "internationalization.currencySign", "")
    setInitialConfig({
      accountSettingsPath,
      myFavoritesPagePath,
      orderHistoryPath,
      myProductsPath,
      myServicesPath,
      orderDetailsUrl,
      continueShopUrl,
      currencySign,
    })
  }

  const handleEditMode = () => {
    setEditMode(!editMode)
  }

  const isSelected = id => selectedItems?.includes(id)

  const handleSelectToggle = (id, itemsList) => {
    const isSelectedData = isSelected(id)
    const selectedItemsData = [...selectedItems]
    if (isSelectedData) {
      const newData = selectedItemsData?.filter(pid => pid !== id)
      setSelectedItems(newData)
      setSelectedALL(false)
      return
    }
    const selectedAll = selectedItemsData?.length + 1 === itemsList?.length
    setSelectedItems([...selectedItemsData, id])
    setSelectedALL(selectedAll)
  }

  const handleCheckAll = () => {
    setSelectedItems([])
    setSelectedALL(false)
  }
  const handleSelectAll = items => {
    if (selectedAll) {
      setSelectedItems([])
      setSelectedALL(false)
    } else {
      setSelectedItems(items)
      setSelectedALL(true)
    }
  }
  const handleDelete = async cb => {
    dispatch(myAccountRemoveItems(selectedItems))
      .unwrap()
      .then(() => {
        dispatch(
          showToast({
            message:
              toasterContent.unfavoriteSuccessMessage || staticTexts.removeItem,
            isVisible: true,
          })
        )
        dispatch(getMyAccountListsWithLineItems())
      })
    setSelectedItems([])
    cb()
    preventBodyScroll(false)
    window.scrollTo({
      top: 1,
      behavior: "smooth",
    })
  }

  const sorts = [
    { name: staticTexts?.newToOld, query: "new" },
    { name: staticTexts?.oldToNew, query: "old" },
  ]

  const signOut = () => {
    dispatch(logout())
  }
  const redirect = url => {
    router.replace(url).then(() => {
      if (router?.asPath.includes(MY_LISTS_PAGE_PATH)) {
        dispatch(getMyAccountListsWithLineItems())
      }
    })
  }
  if (loader) {
    return (
      <MyGenericFiller
        data={componentProps}
        title={isSaveProductToList ? "listTitle" : "favoriteTitle"}
      />
    )
  }
  return (
    <FavoritesView
      loading={status}
      staticTexts={staticTexts}
      tabList={tabListItm}
      productsPerPage={PRODUCTS_PER_PAGE}
      sorts={sorts}
      handleDelete={handleDelete}
      editMode={editMode}
      handleEditMode={handleEditMode}
      locale={configData?.locale}
      handleSelect={handleSelectToggle}
      handleSelectAll={handleSelectAll}
      selectedAll={selectedAll}
      isSelected={isSelected}
      selectedCount={selectedItems?.length}
      authoredContent={componentProps}
      continueShopUrl={configData?.continueShopUrl}
      user={user}
      isAuth={isAuth}
      selectedItems={selectedItems}
      handleCheckAll={handleCheckAll}
      isFavoritesLoading={status}
      presetConfigs={presetConfigs}
      data={menuItems}
      logout={signOut}
      redirect={redirect}
      selectedSortItem={selectedSortItem}
      favPage={true}
      brandSwitcherItems={brandSwitcherItems}
      isSaveProductToList={isSaveProductToList}
      siteName={siteName}
      query={props?.query}
    />
  )
}

export default MyFavorites
